var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "22",
        height: "22",
        viewBox: "0 0 22 22",
      },
    },
    [
      _c("g", { attrs: { fill: _vm.color } }, [
        _c("path", {
          attrs: {
            d: "M20.546 5.414c-6.798-1.351-6.358-1.281-6.512-1.255-0.049 0.008-0.653 0.13-2.059 0.411-0.59-1.7-2.207-2.924-4.105-2.924-1.9 0-3.519 1.226-4.107 2.929l-2.079-0.413c-0.362-0.072-0.701 0.205-0.701 0.576v13.775c0 0.28 0.198 0.521 0.473 0.576 6.741 1.34 6.299 1.253 6.344 1.259 0.142 0.017-0.296 0.090 6.333-1.236l6.186 1.229c0.363 0.072 0.701-0.206 0.701-0.576v-13.775c0-0.28-0.198-0.521-0.473-0.576zM7.869 2.82c1.748 0 3.17 1.422 3.17 3.17 0 1.475-2.36 5.218-3.17 6.457-0.809-1.237-3.17-4.982-3.17-6.457 0-1.748 1.422-3.17 3.17-3.17zM2.156 5.453l1.378 0.274c-0.005 0.087-0.008 0.175-0.008 0.263 0 0.979 0.64 2.559 1.958 4.829 0.769 1.326 1.527 2.464 1.799 2.865v5.365l-5.127-1.019v-12.578zM8.456 13.685c0.272-0.401 1.030-1.539 1.799-2.865 1.317-2.271 1.958-3.851 1.958-4.829 0-0.090-0.003-0.18-0.009-0.268l1.339-0.268v12.578l-5.087 1.018v-5.364zM19.844 19.050l-5.127-1.019v-12.578l5.127 1.019v12.578z",
          },
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M7.869 7.829c1.014 0 1.839-0.825 1.839-1.839s-0.825-1.839-1.839-1.839c-1.014 0-1.839 0.825-1.839 1.839s0.825 1.839 1.839 1.839zM7.869 5.325c0.367 0 0.665 0.298 0.665 0.665s-0.298 0.665-0.665 0.665c-0.367 0-0.665-0.298-0.665-0.665s0.298-0.665 0.665-0.665z",
          },
        }),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }